{
    ".aac": {
        "docType": "AAC audio",
        "mimeType": "audio/aac"
    },
    ".abw": {
        "docType": "AbiWord document",
        "mimeType": "application/x-abiword"
    },
    ".arc": {
        "docType": "Archive document (multiple files embedded)",
        "mimeType": "application/x-freearc"
    },
    ".avi": {
        "docType": "AVI: Audio Video Interleave",
        "mimeType": "video/x-msvideo"
    },
    ".azw": {
        "docType": "Amazon Kindle eBook format",
        "mimeType": "application/vnd.amazon.ebook"
    },
    ".bin": {
        "docType": "Any kind of binary data",
        "mimeType": "application/octet-stream"
    },
    ".bmp": {
        "docType": "Windows OS/2 Bitmap Graphics",
        "mimeType": "image/bmp"
    },
    ".bz": {
        "docType": "BZip archive",
        "mimeType": "application/x-bzip"
    },
    ".bz2": {
        "docType": "BZip2 archive",
        "mimeType": "application/x-bzip2"
    },
    ".csh": {
        "docType": "C-Shell script",
        "mimeType": "application/x-csh"
    },
    ".css": {
        "docType": "Cascading Style Sheets (CSS)",
        "mimeType": "text/css"
    },
    ".csv": {
        "docType": "Comma-separated values (CSV)",
        "mimeType": "text/csv"
    },
    ".doc": {
        "docType": "Microsoft Word",
        "mimeType": "application/msword"
    },
    ".docx": {
        "docType": "Microsoft Word (OpenXML)",
        "mimeType": "application/vnd.openxmlformats-officedocument.wordprocessingml.document"
    },
    ".eot": {
        "docType": "MS Embedded OpenType fonts",
        "mimeType": "application/vnd.ms-fontobject"
    },
    ".epub": {
        "docType": "Electronic publication (EPUB)",
        "mimeType": "application/epub+zip"
    },
    ".gz": {
        "docType": "GZip Compressed Archive",
        "mimeType": "application/gzip"
    },
    ".gif": {
        "docType": "Graphics Interchange Format (GIF)",
        "mimeType": "image/gif"
    },
    ".htm": {
        "docType": "HyperText Markup Language (HTML)",
        "mimeType": "text/html"
    },
    ".html": {
        "docType": "HyperText Markup Language (HTML)",
        "mimeType": "text/html"
    },
    ".ico": {
        "docType": "Icon format",
        "mimeType": "image/vnd.microsoft.icon"
    },
    ".ics": {
        "docType": "iCalendar format",
        "mimeType": "text/calendar"
    },
    ".jar": {
        "docType": "Java Archive (JAR)",
        "mimeType": "application/java-archive"
    },
    ".jpeg": {
        "docType": "JPEG images",
        "mimeType": "image/jpeg"
    },
    ".jpg": {
        "docType": "JPEG images",
        "mimeType": "image/jpeg"
    },
    ".js": {
        "docType": "JavaScript",
        "mimeType": "text/javascript"
    },
    ".json": {
        "docType": "JSON format",
        "mimeType": "application/json"
    },
    ".jsonld": {
        "docType": "JSON-LD format",
        "mimeType": "application/ld+json"
    },
    ".mid": {
        "docType": "Musical Instrument Digital Interface (MIDI)",
        "mimeType": "audio/midi"
    },
    ".midi": {
        "docType": "Musical Instrument Digital Interface (MIDI)",
        "mimeType": "audio/x-midi"
    },
    ".mjs": {
        "docType": "JavaScript module",
        "mimeType": "text/javascript"
    },
    ".mp3": {
        "docType": "MP3 audio",
        "mimeType": "audio/mpeg"
    },
    ".mpeg": {
        "docType": "MPEG Video",
        "mimeType": "video/mpeg"
    },
    ".mpkg": {
        "docType": "Apple Installer Package",
        "mimeType": "application/vnd.apple.installer+xml"
    },
    ".odp": {
        "docType": "OpenDocument presentation document",
        "mimeType": "application/vnd.oasis.opendocument.presentation"
    },
    ".ods": {
        "docType": "OpenDocument spreadsheet document",
        "mimeType": "application/vnd.oasis.opendocument.spreadsheet"
    },
    ".odt": {
        "docType": "OpenDocument text document",
        "mimeType": "application/vnd.oasis.opendocument.text"
    },
    ".oga": {
        "docType": "OGG audio",
        "mimeType": "audio/ogg"
    },
    ".ogv": {
        "docType": "OGG video",
        "mimeType": "video/ogg"
    },
    ".ogx": {
        "docType": "OGG",
        "mimeType": "application/ogg"
    },
    ".opus": {
        "docType": "Opus audio",
        "mimeType": "audio/opus"
    },
    ".otf": {
        "docType": "OpenType font",
        "mimeType": "font/otf"
    },
    ".png": {
        "docType": "Portable Network Graphics",
        "mimeType": "image/png"
    },
    ".pdf": {
        "docType": "Adobe Portable Document Format (PDF)",
        "mimeType": "application/pdf"
    },
    ".php": {
        "docType": "Hypertext Preprocessor (Personal Home Page)",
        "mimeType": "application/x-httpd-php"
    },
    ".ppt": {
        "docType": "Microsoft PowerPoint",
        "mimeType": "application/vnd.ms-powerpoint"
    },
    ".pptx": {
        "docType": "Microsoft PowerPoint (OpenXML)",
        "mimeType": "application/vnd.openxmlformats-officedocument.presentationml.presentation"
    },
    ".rar": {
        "docType": "RAR archive",
        "mimeType": "application/vnd.rar"
    },
    ".rtf": {
        "docType": "Rich Text Format (RTF)",
        "mimeType": "application/rtf"
    },
    ".sh": {
        "docType": "Bourne shell script",
        "mimeType": "application/x-sh"
    },
    ".svg": {
        "docType": "Scalable Vector Graphics (SVG)",
        "mimeType": "image/svg+xml"
    },
    ".swf": {
        "docType": "Small web format (SWF) or Adobe Flash document",
        "mimeType": "application/x-shockwave-flash"
    },
    ".tar": {
        "docType": "Tape Archive (TAR)",
        "mimeType": "application/x-tar"
    },
    ".tif": {
        "docType": "Tagged Image File Format (TIFF)",
        "mimeType": "image/tiff"
    },
    ".tiff": {
        "docType": "Tagged Image File Format (TIFF)",
        "mimeType": "image/tiff"
    },
    ".ts": {
        "docType": "MPEG transport stream",
        "mimeType": "video/mp2t"
    },
    ".ttf": {
        "docType": "TrueType Font",
        "mimeType": "font/ttf"
    },
    ".txt": {
        "docType": "Text, (generally ASCII or ISO 8859-n)",
        "mimeType": "text/plain"
    },
    ".vsd": {
        "docType": "Microsoft Visio",
        "mimeType": "application/vnd.visio"
    },
    ".wav": {
        "docType": "Waveform Audio Format",
        "mimeType": "audio/wav"
    },
    ".weba": {
        "docType": "WEBM audio",
        "mimeType": "audio/webm"
    },
    ".webm": {
        "docType": "WEBM video",
        "mimeType": "video/webm"
    },
    ".webp": {
        "docType": "WEBP image",
        "mimeType": "image/webp"
    },
    ".woff": {
        "docType": "Web Open Font Format (WOFF)",
        "mimeType": "font/woff"
    },
    ".woff2": {
        "docType": "Web Open Font Format (WOFF)",
        "mimeType": "font/woff2"
    },
    ".xhtml": {
        "docType": "XHTML",
        "mimeType": "application/xhtml+xml"
    },
    ".xls": {
        "docType": "Microsoft Excel",
        "mimeType": "application/vnd.ms-excel"
    },
    ".xlsm": {
        "docType": "Microsoft Excel (OpenXML)",
        "mimeType": "application/vnd.ms-excel.sheet.macroenabled.12"
    },
    ".xlsx": {
        "docType": "Microsoft Excel (OpenXML)",
        "mimeType": "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
    },
    ".xml": {
        "docType": "XML",
        "mimeType": "application/xml"
    },
    ".xul": {
        "docType": "XUL",
        "mimeType": "application/vnd.mozilla.xul+xml"
    },
    ".zip": {
        "docType": "ZIP archive",
        "mimeType": "application/zip"
    },
    ".3gp": {
        "docType": "3GPP audio/video container",
        "mimeType": "video/3gpp"
    },
    ".3g2": {
        "docType": "3GPP2 audio/video container",
        "mimeType": "video/3gpp2"
    },
    ".7z": {
        "docType": "7-zip archive",
        "mimeType": "application/x-7z-compressed"
    }
}
